export default function genererCritereRecherche() {
  return {
    tiers: [],
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    libelle: null,
    odIds: [],
  };
}
